module.exports = __webpack_public_path__ + "static/media/hands_23.5377e273.svg";